// extracted by mini-css-extract-plugin
export default {"wrapper":"MwNZOTkEwZbSOHELFjke","field":"z50LQZC6smBPaB9KKvCz","periodField":"cFlp2xUDYiD9tsGfrvQe","yearField":"lGAZHa5yy5Pd6QjdTkUs"};